import { useContext } from 'react';
import { AllSelectedTableItemsContext } from '@/providers/AllSelectedTableItemsProvider';
import { TableHead } from '../TableHead';
import { Checkbox } from '@/components/Controls/Checkbox';
import Pagination from '@/components/Common/Pagination';
import { NoTableDataFound } from '@/components/Custom/NotFound/NoTableDataFound';
import { TFunction } from 'i18next';
import { useUserRole } from '@/hooks/auth.hooks';
import './styles.css';

interface DatatableProp {
  t?: TFunction<undefined>;
  headers: React.ReactNode;
  data: React.ReactNode;
  canSelectItems?: boolean;
  showPagination?: boolean;
  totalPages?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
}

export const Datatable = ({
  t,
  headers,
  data,
  canSelectItems = true,
  showPagination,
  totalPages,
  currentPage,
  onPageChange,
}: DatatableProp) => {
  const { allTableItemsSelected, setAllTableItemsSelected } = useContext(
    AllSelectedTableItemsContext
  );

  const { hasNoRole, isModerator } = useUserRole();

  return (
    <>
      <div className="scrollable-x-auto">
        <table
          className="table table-auto table-border"
          data-datatable-table="true"
        >
          <thead>
            <tr>
              {!hasNoRole && !isModerator && data && canSelectItems && (
                <TableHead thClassName="sticky-select-column">
                  <Checkbox
                    checked={allTableItemsSelected}
                    onChange={() =>
                      setAllTableItemsSelected((prevState) => !prevState)
                    }
                  />
                </TableHead>
              )}

              {headers}
            </tr>
          </thead>
          <tbody>{data}</tbody>
        </table>
        {!data && (
          <div className="sticky left-0">
            <NoTableDataFound t={t} />
          </div>
        )}
      </div>
      {showPagination && (
        <div className="mt-7 mb-2 border-t-0 flex justify-end gap-5 text-gray-600 text-2sm font-medium">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </>
  );
};
